export const WIDGET_TYPE_CALENDAR = 'calendar';
export const WIDGET_TYPE_PARTICIPANT_SEARCH = 'participant_search';
